/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ArchitectureTypesEnum } from './ArchitectureTypesEnum';
import {
    ArchitectureTypesEnumFromJSON,
    ArchitectureTypesEnumFromJSONTyped,
    ArchitectureTypesEnumToJSON,
} from './ArchitectureTypesEnum';
import type { BackendTypesEnum } from './BackendTypesEnum';
import {
    BackendTypesEnumFromJSON,
    BackendTypesEnumFromJSONTyped,
    BackendTypesEnumToJSON,
} from './BackendTypesEnum';

/**
 * 
 * @export
 * @interface VmTypeListSchema
 */
export interface VmTypeListSchema {
    /**
     * 
     * @type {string}
     * @memberof VmTypeListSchema
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof VmTypeListSchema
     */
    cores: number;
    /**
     * 
     * @type {number}
     * @memberof VmTypeListSchema
     */
    gpus: number;
    /**
     * 
     * @type {string}
     * @memberof VmTypeListSchema
     */
    gpuName?: string;
    /**
     * 
     * @type {number}
     * @memberof VmTypeListSchema
     */
    memory: number;
    /**
     * 
     * @type {ArchitectureTypesEnum}
     * @memberof VmTypeListSchema
     */
    arch?: ArchitectureTypesEnum;
    /**
     * 
     * @type {boolean}
     * @memberof VmTypeListSchema
     */
    enabled: boolean;
    /**
     * 
     * @type {number}
     * @memberof VmTypeListSchema
     */
    approximateHourlyPrice?: number;
    /**
     * 
     * @type {BackendTypesEnum}
     * @memberof VmTypeListSchema
     */
    backendType: BackendTypesEnum;
}

/**
 * Check if a given object implements the VmTypeListSchema interface.
 */
export function instanceOfVmTypeListSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "cores" in value;
    isInstance = isInstance && "gpus" in value;
    isInstance = isInstance && "memory" in value;
    isInstance = isInstance && "enabled" in value;
    isInstance = isInstance && "backendType" in value;

    return isInstance;
}

export function VmTypeListSchemaFromJSON(json: any): VmTypeListSchema {
    return VmTypeListSchemaFromJSONTyped(json, false);
}

export function VmTypeListSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): VmTypeListSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'cores': json['cores'],
        'gpus': json['gpus'],
        'gpuName': !exists(json, 'gpu_name') ? undefined : json['gpu_name'],
        'memory': json['memory'],
        'arch': !exists(json, 'arch') ? undefined : ArchitectureTypesEnumFromJSON(json['arch']),
        'enabled': json['enabled'],
        'approximateHourlyPrice': !exists(json, 'approximate_hourly_price') ? undefined : json['approximate_hourly_price'],
        'backendType': BackendTypesEnumFromJSON(json['backend_type']),
    };
}

export function VmTypeListSchemaToJSON(value?: VmTypeListSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'cores': value.cores,
        'gpus': value.gpus,
        'gpu_name': value.gpuName,
        'memory': value.memory,
        'arch': ArchitectureTypesEnumToJSON(value.arch),
        'enabled': value.enabled,
        'approximate_hourly_price': value.approximateHourlyPrice,
        'backend_type': BackendTypesEnumToJSON(value.backendType),
    };
}

